import {
  CallCreationRequest,
  CallDto,
  CallUpdateRequestDto,
  CallWithFeedItemDto,
  CommunicationGuidanceDto,
  CreateVoiceCallAuditRequestDto,
  FilterGroupDto,
  PaginatedCallsDto,
  PhoneNumberTwilioDetailsDto,
  ReturnCallCreationRequestDto,
  SuggestionsDto,
  VoiceCallAuditDto,
  VoiceCallRecordingDto,
  VoiceCallRecordingUpdateDto,
} from '@act/shared/data-transfer-objects';
import { EndpointDefinition } from '../utils/endpoint-definition';
import { CommunicationTiming } from '@act/shared/types';

export const callsRequests = {
  getCalls: EndpointDefinition.get<
    PaginatedCallsDto,
    {
      orderBy?: string;
      orderDirection?: string;
      'page-start'?: number;
      'page-size'?: number;
      guideIds?: string[];
      statuses?: string[];
      directionType?: 'incoming' | 'outgoing';
    }
  >({
    name: 'getCalls',
    route: '/calls',
  }),

  createCall: EndpointDefinition.post<
    CallWithFeedItemDto,
    CallCreationRequest,
    null
  >({
    name: 'createCall',
    route: '/calls',
  }),

  returnCall: EndpointDefinition.post<
    CallWithFeedItemDto,
    ReturnCallCreationRequestDto,
    null
  >({
    name: 'returnCall',
    route: '/calls/return',
  }),

  updateCall: EndpointDefinition.patch<
    CallDto,
    CallUpdateRequestDto,
    { id: number }
  >({
    name: 'updateCall',
    route: '/calls/:id',
  }),

  updateSubjectId: EndpointDefinition.patch<
    CallDto,
    { subjectId: string },
    { id: number }
  >({
    name: 'updateSubjectId',
    route: '/calls/:id/subjectId',
  }),

  updateCallNoFollowUpNeeded: EndpointDefinition.post<
    CallDto,
    { noFollowUpNeeded: boolean },
    { callId: number }
  >({
    name: 'updateCallNoFollowUpNeeded',
    route: '/calls/:callId/no_follow_up_needed',
  }),

  getPhoneDetailsFromTwilio: EndpointDefinition.get<
    PhoneNumberTwilioDetailsDto,
    { phoneNumber: string }
  >({
    name: 'getPhoneDetailsFromTwilio',
    route: '/interaction/phone-numbers/twilio-details',
  }),

  getCallsFilters: EndpointDefinition.get<FilterGroupDto, { named?: string }>({
    name: 'getCallsFilters',
    route: '/calls/filters',
  }),

  updateVoiceCallRecording: EndpointDefinition.patch<
    VoiceCallRecordingDto,
    VoiceCallRecordingUpdateDto,
    { id: number }
  >({
    name: 'updateVoiceCallRecording',
    route: '/calls/voice-call-recording/:id',
  }),

  createCallReviewTask: EndpointDefinition.post<
    VoiceCallAuditDto[],
    CreateVoiceCallAuditRequestDto,
    { callId: number }
  >({
    name: 'createCallReviewTasks',
    route: '/calls/:callId/audit',
  }),

  getCallReviewTask: EndpointDefinition.get<
    VoiceCallAuditDto[],
    { callId: number; assigneeId?: string }
  >({
    name: 'getCallReviewTask',
    route: '/calls/:callId/audit/tasks',
  }),

  updateCallReview: EndpointDefinition.patch<
    VoiceCallAuditDto,
    { actionTaken?: boolean },
    { auditId: number }
  >({
    name: 'updateCallReview',
    route: '/calls/audit/tasks/:auditId',
  }),

  getCommunicationGuidances: EndpointDefinition.get<
    CommunicationGuidanceDto[],
    {
      memberId?: string;
      clientId?: number;
      communicationTiming?: CommunicationTiming;
    }
  >({
    name: 'getCommunicationGuidances',
    route: '/interaction/guidance',
  }),

  getSuggestions: EndpointDefinition.get<SuggestionsDto, { id: number }>({
    name: 'getSuggestions',
    route: '/calls/:id/llm_suggestions',
  }),
};
